module.exports = __webpack_public_path__ + "static/media/BrightBee_Platform-Screens-1.f065e4f9.png";